import "../styles/general.css";
import "react-multi-date-picker/styles/backgrounds/bg-dark.css";

import { useCookies } from "react-cookie";
import React, { useContext, useEffect, useRef, useState } from "react";
import axios from "axios";
import QRCode from "react-qr-code";
import MaskedInput from "react-text-mask";
import DatePicker, { DateObject } from "react-multi-date-picker";
import { BsTrash3 } from "react-icons/bs";
import { FaWheelchair } from "react-icons/fa";

import BrandSelect from "../components/brandselect/BrandSelect";
import DesktopView from "../components/desktopview/DesktopView";
import Header from "../components/header/Header";
import BlueLoader from "../components/loader/BlueLoader";
import Loader from "../components/loader/Loader";
import MessageModals from "../components/modals/MessageModals";
import ModelSelect from "../components/modelselect/ModelSelect";
import ConformationModal from "../components/modals/ConformationModal";
import globalContext from "../Contexts/GlobalContext";
import Info from "../components/info/Info";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import PlateModal from "../components/platemodal/PlateModal";
import {
  getValidPlateNumber,
  setValidPlateNumber,
} from "../utils/plateLetterHandler";
import CarQr from "../components/modals/CarQr";
import { SERVERMESSAGE } from "../constants/serverMessage";
import { SERVERMODE } from "../constants/serverMode";
import { handleServerMode } from "../utils/handleServer";
import { useNavigate } from "react-router-dom";
import ChangeKmsConf from "../components/modals/ChangeKmsConf";
import useRequestHeader from "../hooks/useRequestHeader";
import { addCommas, p2e, removeNonNumeric } from "../utils/functions";

export default function CarDetails() {
  const BASE_URL = process.env.REACT_APP_ROOT_API_ADDRESS;
  const contextData = useContext(globalContext);
  const navigate = useNavigate();

  // ------>
  const [prevPlate, setPrevPlate] = useState("");

  // ------>
  const [cookies, setCookies, removeCookies] = useCookies();
  const requestHeader = useRequestHeader();

  const plk1 = useRef();
  const plk2 = useRef();
  const plk3 = useRef();

  const [IsKmUpdateConfOpen, setIsKmUpdateConfOpen] = useState(false);
  const [kmUpdateConfMessage, setkmUpdateConfMessage] = useState("");
  const [kmUpdateConfTitle, setKmUpdateConfTitle] = useState("");

  /// pelaks values state start ///
  const [plk1Value, setPlk1Value] = useState("");
  const [plk2Value, setPlk2Value] = useState("");
  const [plk3Value, setPlk3Value] = useState("");
  const [plk4Value, setPlk4Value] = useState("");
  const [plk5Value, setPlk5Value] = useState("");
  const [plk6Value, setPlk6Value] = useState("");
  const [plk7Value, setPlk7Value] = useState("");

  const [carDetailsLetter, setCarDetailsLetter] = useState("");

  /// pelaks values state end ///

  ///// new plate values start //////
  const [pInp1, setPInp1] = useState("");
  const [pInp2, setPInp2] = useState("");
  const [pInp3, setPInp3] = useState("");
  ///// new plate values end //////

  //// inputs feild states start ////

  const [brand, setBrand] = useState("");
  const [model, setModel] = useState("");
  const [prdY, setPrdY] = useState("");
  const [func, setFunc] = useState("");
  const [insuranceDate, setInsuranceDate] = useState("");
  const [lastReplace, setLastReplace] = useState("");
  const [avgFunc, setAvgFunc] = useState("");
  const [engineNumber, setEngineNumber] = useState("");
  const [frameNumber, setFrameNumber] = useState("");

  const [insuranceDateValue, setInsuranceDateValue] = useState(null);
  const [pupuY, setPupuY] = useState("");

  const [prDateValue, setPrDateValue] = useState(null);

  const [mustSendInsuranceDate, setMustSendInsuranceDate] = useState("");

  const [categoryID, setCategoryID] = useState("");
  //// inputs feild states end ////

  const [isLoading, setIsLoading] = useState(false);

  /// car details input handler start ///

  const lastReplaceHandle = (e) => {
    setLastReplace(p2e(e.target.value));
    setLastReplace(p2e(e.target.value));
  };

  const engineNumberHandle = (e) => {
    setEngineNumber(e.target.value);
  };
  const frameNumberHandle = (e) => {
    setFrameNumber(e.target.value);
  };
  /// car details input handler end ///setCarDetailsLetter
  // ---->
  const [carID, setCarID] = useState("000000000");
  const [plateCheck, setPlateCheck] = useState("");
  const [brandCheck, setBrandCheck] = useState("");
  const [modelCheck, setModelCheck] = useState("");
  const [prdYCheck, setPrdYCheck] = useState("");
  const [funcCheck, setFuncCheck] = useState("");
  const [insuranceDateCheck, setInsuranceDateCheck] = useState("");
  const [lastReplaceCheck, setLastReplaceCheck] = useState("");
  const [avgFuncCheck, setAvgFuncCheck] = useState("");
  const [engineNumberCheck, setEngineNumberCheck] = useState("");
  const [frameNumberCheck, setFrameNumberCheck] = useState("");

  // ----->

  const updateCarsStorage = (plate, model) => {
    try {
      var localStorageCars = JSON.parse(localStorage?.getItem("cars"));

      for (let i = 0; i < localStorageCars?.length; i++) {
        if (localStorageCars[i].plate === plate) {
          localStorageCars[i].model = model;
          break; // Exit the loop once the object is found and updated
        }
      }

      localStorage.setItem("cars", JSON.stringify(localStorageCars));
    } catch (e) {}
  };

  useEffect(() => {
    setIsLoadingGet(true);
    const config = {
      headers: requestHeader,
    };
    axios
      .post(
        `${BASE_URL}/car/detailCar`,
        {
          plate: cookies?.plate,
        },
        config
      )
      .then((res) => {
        var responseMode = res?.data?.Mode;
        var responseMessage = res?.data?.Message;
        setIsLoadingGet(false);
        switch (responseMode) {
          case SERVERMODE.REQUEST_OK: {
            if (res?.data?.Data?.carID) {
              setCarID(res?.data?.Data?.carID);
            }
            if (res?.data?.Data?.chassisNumber) {
              setFrameNumber(res?.data?.Data?.chassisNumber);
              setFrameNumberCheck(res?.data?.Data?.chassisNumber);
            }
            if (res?.data?.Data?.engineNumber) {
              setEngineNumber(res?.data?.Data?.engineNumber);
              setEngineNumberCheck(res?.data?.Data?.engineNumber);
            }
            if (res?.data?.Data?.kmCurrent) {
              setFunc(res?.data?.Data?.kmCurrent);
              setFuncCheck(res?.data?.Data?.kmCurrent);
            }
            if (res?.data?.Data?.kmLastReplace) {
              setLastReplace(
                res?.data?.Data?.kmLastReplace
                  ? res?.data?.Data?.kmLastReplace
                  : 0
              );
              setLastReplaceCheck(res?.data?.Data?.kmLastReplace);
            }
            if (res?.data?.Data?.thirdInsurance) {
              setInsuranceDate(
                res?.data?.Data?.thirdInsurance.replaceAll("-", "/")
              );
              var dArr0 = res?.data?.Data?.thirdInsurance.split("-");

              if (parseInt(dArr0[1]) < 10) dArr0[1] = `0${parseInt(dArr0[1])}`;
              if (parseInt(dArr0[2]) < 10) dArr0[2] = `0${parseInt(dArr0[2])}`;
              var newD0 = `${dArr0[0]}/${dArr0[1]}/${dArr0[2]}`;
              setInsuranceDateCheck(newD0);

              setInsuranceDateValue(
                new DateObject({
                  date: `${res?.data?.Data?.thirdInsurance.replaceAll(
                    "-",
                    "/"
                  )}`,
                  calendar: persian,
                })
              );
              var dArr = res?.data?.Data?.thirdInsurance.split("-");
              if (parseInt(dArr0[1]) < 10) dArr[1] = `0${parseInt(dArr0[1])}`;
              if (parseInt(dArr0[2]) < 10) dArr[2] = `0${parseInt(dArr0[2])}`;
              var newD = `${dArr[0]}/${dArr[1]}/${dArr[2]}`;
              setMustSendInsuranceDate(newD);
            }
            if (res?.data?.Data?.kmAverage) {
              setAvgFunc(res?.data?.Data?.kmAverage);
              setAvgFuncCheck(res?.data?.Data?.kmAverage);
            }
            if (res?.data?.Data?.year) {
              setPrdY(res?.data?.Data?.year);
              setPrdYCheck(res?.data?.Data?.year);
              if (res?.data?.Data?.year < 1930) {
                setPrDatePickerCalender(persian);

                setPrDateValue(
                  new DateObject(`${Number(res?.data?.Data?.year) + 621}/12/12`)
                );
              } else {
                setPrDatePickerCalender("");

                setPrDateValue(
                  new DateObject(`${res?.data?.Data?.year}/12/12`)
                );
              }
            }
            if (res?.data?.Data?.company) {
              setBrand(res?.data?.Data?.company);
              setBrandCheck(res?.data?.Data?.company);
              setNewBrand(res?.data?.Data?.company);
            }
            if (res?.data?.Data?.model) {
              setModel(res?.data?.Data?.model);
              setModelCheck(res?.data?.Data?.model);
              setNewModel(res?.data?.Data?.model);
            }
            if (res?.data?.Data?.plate) {
              let p = res?.data?.Data?.plate;
              setPrevPlate(p);
              setPInp1(getValidPlateNumber(p, "1"));
              setPInp2(getValidPlateNumber(p, "2"));
              setPInp3(getValidPlateNumber(p, "3"));
              setPlateModalLetter(getValidPlateNumber(p, "S"));
              setPlateCheck(res?.data?.Data?.plate);
            }

            updateCarsStorage(cookies?.plate, res?.data?.Data?.model);

            break;
          }
          default: {
            handleServerMode(
              responseMode,
              responseMessage,
              contextData,
              cookies,
              removeCookies,
              navigate
            );
          }
        }
      })
      .catch((err) => {
        setIsLoadingGet(false);
      });
  }, []);

  const changeCarDetails = (ok) => {
    if (
      setValidPlateNumber(pInp1, plateModalLetter, pInp2, pInp3).length === 9
    ) {
      if (
        plateCheck ===
          setValidPlateNumber(pInp1, plateModalLetter, pInp2, pInp3) &&
        brandCheck === brand &&
        modelCheck === model &&
        funcCheck === func?.replaceAll(",", "") &&
        engineNumberCheck === engineNumber &&
        frameNumberCheck === frameNumber &&
        prdYCheck === `${prDateValue?.year}` &&
        insuranceDateCheck === mustSendInsuranceDate.replaceAll("-", "/")
      ) {
        contextData.setIsToastOpen(true);
        contextData.setToastMessage("اطلاعات تغییر نکرده است");
      } else {
        if (!func?.replaceAll(",", "")) {
          contextData.setIsToastOpen(true);
          contextData.setToastMessage("کارکرد نمیتواند خالی باشد");
        }
        if (prdY.length < 4) {
          contextData.setIsToastOpen(true);
          contextData.setToastMessage(" سال تولید را به درستی وارد نمایید");
        }

        if (
          !mustSendInsuranceDate
            .replaceAll("-", "/")
            .match(/^\d{4}([/])\d{2}\1\d{2}$/)
        ) {
          contextData.setIsToastOpen(true);
          contextData.setToastMessage(
            "تاریخ انقضا بیمه شخص ثالث به درستی وارد نمایید"
          );
        }
        if (
          func?.replaceAll(",", "") &&
          prdY.length >= 4 &&
          mustSendInsuranceDate
            .replaceAll("-", "/")
            .match(/^\d{4}([/])\d{2}\1\d{2}$/)
        ) {
          setIsLoading(true);
          let sendParams = {};
          if (
            prevPlate !==
            setValidPlateNumber(pInp1, plateModalLetter, pInp2, pInp3)
          ) {
            sendParams = {
              plate: prevPlate,
              plateNew: setValidPlateNumber(
                pInp1,
                plateModalLetter,
                pInp2,
                pInp3
              ),
              kmCurrent: func?.replaceAll(",", ""),
              chassisNumber: frameNumber,
              engineNumber: engineNumber,
              carID: carID,
              category: `${newCategoryID}`,
              company: newBrand,
              model: newModel,
              year: `${prDateValue?.year}`,
              thirdInsurance: mustSendInsuranceDate.replaceAll("/", "-"),
            };
          } else {
            sendParams = {
              plate: prevPlate,
              kmCurrent: func?.replaceAll(",", ""),
              chassisNumber: frameNumber,
              engineNumber: engineNumber,
              carID: carID,
              category: `${newCategoryID}`,
              company: newBrand,
              model: newModel,
              year: `${prDateValue?.year}`,
              thirdInsurance: mustSendInsuranceDate.replaceAll("/", "-"),
            };
          }
          if (ok === "true") {
            sendParams.isValid = "true";
          }
          const config = {
            headers: requestHeader,
          };
          axios
            .post(`${BASE_URL}/car/updateDetailCar`, sendParams, config)
            .then((res) => {
              var responseMode = res?.data?.Mode;
              var responseMessage = res?.data?.Message;
              switch (responseMode) {
                case SERVERMODE.REQUEST_OK: {
                  contextData.setIsToastOpen(true);
                  contextData.setToastMessage(SERVERMESSAGE.SUCCESS_EDIT_DATA);
                  contextData.setChangeKmModalKM(func?.replaceAll(",", ""));
                  contextData.setIsToastOpen(true);
                  contextData.setToastMessage(
                    SERVERMESSAGE.successUpdateDetailCar
                  );
                  contextData.setChangeKmModalIsOpen(false);
                  setCookies("kmCurrent", func?.replaceAll(",", ""), {
                    path: "/",
                  });
                  setPlateCheck(
                    setValidPlateNumber(pInp1, plateModalLetter, pInp2, pInp3)
                  );
                  setBrandCheck(newBrand);
                  setModelCheck(newModel);
                  setPrdYCheck(`${prDateValue?.year}`);
                  setFuncCheck(func?.replaceAll(",", ""));
                  setAvgFuncCheck(avgFunc);
                  setEngineNumberCheck(engineNumber);
                  setFrameNumberCheck(frameNumber);
                  setInsuranceDateCheck(
                    mustSendInsuranceDate.replaceAll("-", "/")
                  );
                  setCookies(
                    "plate",
                    setValidPlateNumber(pInp1, plateModalLetter, pInp2, pInp3),
                    { path: "/" }
                  );
                  break;
                }
                case SERVERMODE.DATA_ILLOGICAL: {
                  setIsKmUpdateConfOpen(true);
                  setkmUpdateConfMessage(res?.data?.Message);
                  setKmUpdateConfTitle("ثبت کیلومتر کارکرد نامعقول");
                  break;
                }
                default: {
                  handleServerMode(
                    responseMode,
                    responseMessage,
                    contextData,
                    cookies,
                    removeCookies,
                    navigate
                  );
                }
              }
              setIsLoading(false);
            })
            .catch((err) => {
              setIsLoading(false);
              contextData.setIsToastOpen(true);
              contextData.setToastMessage("ارتباط با سرور دچار مشکل شده است");
            });
        }
      }
    } else {
      contextData.setIsToastOpen(true);
      contextData.setToastMessage("پلاک خود را به درستی وارد نمایید");
    }
  };

  //// check if brand and model in change able start  ///
  const [BMChangeAble, setBMChangeAble] = useState(
    carID?.includes("IRI") ? true : false
  );
  const [newBrand, setNewBrand] = useState("");
  const [newModel, setNewModel] = useState("");
  const [newCategoryID, setNewCategoryID] = useState("");
  //// check if brand and model in change able end ///

  const [isConformationModalOpen, setIsConformationModalOpen] = useState(false);
  //// delete car function start ////
  const deleteCar = () => {
    setIsConformationModalOpen(true);
  };
  //// delete car function end ////
  useEffect(() => {}, [
    plk1Value,
    plk2Value,
    carDetailsLetter,
    plk3Value,
    plk4Value,
    plk5Value,
    plk6Value,
    plk7Value,
  ]);

  const [prDatePickerCalender, setPrDatePickerCalender] = useState(persian);

  const digits = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];

  const datePickerRefInsurance = useRef();
  const datePickerRefPr = useRef();

  const [isPlateModalOpen, setIsPlateModalOpen] = useState(false);
  const [plateModalLetter, setPlateModalLetter] = useState("");
  const [isPlateModalNextInputOpen, setIsPlateModalNextInputOpen] =
    useState(false);

  //// useeffect for focus on plk2 start ////
  useEffect(() => {
    if (isPlateModalNextInputOpen) {
      const end = pInp2.length;
      plk2.current.inputElement.focus();
      plk2.current.inputElement.setSelectionRange(end, end);
      setIsPlateModalNextInputOpen(false);
    }
  }, [isPlateModalNextInputOpen]);
  //// useeffect for focus on plk2 end ////

  const [isLoadingGget, setIsLoadingGet] = useState(false);

  const [isCarQrOpen, setIsCarQrOpen] = useState(false);
  const [isLoadingQrCode, setIsLoadingQrCode] = useState(false);
  const [carQrToken, setCarQrToken] = useState("");
  const openQrCodeModal = () => {
    setIsCarQrOpen(true);
    setIsLoadingQrCode(true);
    const config = {
      headers: requestHeader,
    };
    axios
      .post(
        `${BASE_URL}/car/generateQrCode`,
        {
          plate: cookies?.plate,
        },
        config
      )
      .then((res) => {
        var responseMode = res?.data?.Mode;
        var responseMessage = res?.data?.Message;
        if (responseMode === SERVERMODE.REQUEST_OK) {
          setCarQrToken(res?.data?.Data);
          setIsLoadingQrCode(false);
        } else {
          handleServerMode(
            responseMode,
            responseMessage,
            contextData,
            cookies,
            removeCookies,
            navigate
          );
        }
      })
      .catch((err) => {
        setIsLoadingQrCode(false);
        contextData.setIsToastOpen(true);
        contextData.setToastMessage("ارتباط با سرور دچار مشکل شده است");
      });
  };
  return (
    <>
      <div className="hidden min-[1024px]:block">
        <DesktopView />
      </div>

      {/* //// mobile view start //// */}
      <div className="w-full addCarDetailsBody min-[1024px]:hidden ">
        {contextData?.isInfoOpen && (
          <Info
            infoText={
              "کاربر عزیز مشخصات خودرو شما در این صفحه نمایش داده شده و کد اختصاصی خودرو شما در سامانه اسکارپین در قسمت بالا درج شده است. شما می‌توانید تمامی پارامترهای موجود را در صورت نیاز ویرایش نمایید."
            }
          />
        )}

        {isConformationModalOpen && (
          <ConformationModal
            setIsConformationModalOpen={setIsConformationModalOpen}
          />
        )}
        <img
          src="../assets/images/body/body-bgimg.png"
          alt=""
          className="absolute w-full h-full top-0 right-0 -z-50"
        />
        {contextData.isToastOpen && (
          <MessageModals
            setIsOpen={contextData.setIsToastOpen}
            message={contextData.toastMessage}
          />
        )}
        {isPlateModalOpen && (
          <PlateModal
            isPlateModalOpen={isPlateModalOpen}
            setIsPlateModalOpen={setIsPlateModalOpen}
            plateModalLetter={plateModalLetter}
            setPlateModalLetter={setPlateModalLetter}
            isPlateModalNextInputOpen={isPlateModalNextInputOpen}
            setIsPlateModalNextInputOpen={setIsPlateModalNextInputOpen}
          />
        )}
        {isCarQrOpen && (
          <CarQr
            setIsCarQrOpen={setIsCarQrOpen}
            isLoadingQrCode={isLoadingQrCode}
            setIsLoadingQrCode={setIsLoadingQrCode}
            carQrToken={carQrToken}
            setCarQrToken={setCarQrToken}
          />
        )}
        {IsKmUpdateConfOpen && (
          <ChangeKmsConf
            setIsKmUpdateConfOpen={setIsKmUpdateConfOpen}
            sendAllData={changeCarDetails}
            message={kmUpdateConfMessage}
            title={kmUpdateConfTitle}
          />
        )}
        <Header relt="relative" />
        <div className="absolute w-full flex flex-col bottom-[24.5vw] top-[17.2vw] items-center justify-start overflow-hidden">
          {isLoadingGget && (
            <>
              <div className="absolute w-[92.45vw] h-[33.6vw] top-0 flex items-center justify-center z-[600]">
                <Loader width={12} top={0} right={0} />
              </div>
              <div className="absolute w-[92.45vw] h-[33.6vw] top-0 flex items-center justify-center z-[550]">
                <svg
                  width="92.45vw"
                  height="33.6vw"
                  viewBox="0 0 393 144"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="absolute backdrop-blur-[2px]"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.35998 0.865257H136.823C155.489 6.84699 175.38 10.0901 196.028 10.0901C216.676 10.0901 236.567 6.84699 255.233 0.865257H383.696C388.092 0.865257 391.695 4.46871 391.695 8.86492V135.13C391.695 139.526 388.092 143.13 383.696 143.13H8.32395C3.92773 143.13 0.32428 139.526 0.32428 135.13V8.86492C0.32428 4.46871 3.92773 0.865257 8.32395 0.865257H8.35998Z"
                    fill="#001D26"
                    fillOpacity="0.701961"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.35998 0.865257H136.823C155.489 6.84699 175.38 10.0901 196.028 10.0901C216.676 10.0901 236.567 6.84699 255.233 0.865257H383.696C388.092 0.865257 391.695 4.46871 391.695 8.86492V135.13C391.695 139.526 388.092 143.13 383.696 143.13H8.32395C3.92773 143.13 0.32428 139.526 0.32428 135.13V8.86492C0.32428 4.46871 3.92773 0.865257 8.32395 0.865257H8.35998Z"
                    stroke="#00FFF2"
                    strokeWidth="0.756725"
                    strokeMiterlimit="2.61313"
                  />
                </svg>
              </div>
            </>
          )}
          <div className="absolute w-[92.45vw] h-[33.6vw] top-0 flex items-center justify-center">
            <svg
              width="92.45vw"
              height="33.6vw"
              viewBox="0 0 393 144"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.35998 0.865257H136.823C155.489 6.84699 175.38 10.0901 196.028 10.0901C216.676 10.0901 236.567 6.84699 255.233 0.865257H383.696C388.092 0.865257 391.695 4.46871 391.695 8.86492V135.13C391.695 139.526 388.092 143.13 383.696 143.13H8.32395C3.92773 143.13 0.32428 139.526 0.32428 135.13V8.86492C0.32428 4.46871 3.92773 0.865257 8.32395 0.865257H8.35998Z"
                fill="#001D26"
                fillOpacity="0.701961"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.35998 0.865257H136.823C155.489 6.84699 175.38 10.0901 196.028 10.0901C216.676 10.0901 236.567 6.84699 255.233 0.865257H383.696C388.092 0.865257 391.695 4.46871 391.695 8.86492V135.13C391.695 139.526 388.092 143.13 383.696 143.13H8.32395C3.92773 143.13 0.32428 139.526 0.32428 135.13V8.86492C0.32428 4.46871 3.92773 0.865257 8.32395 0.865257H8.35998Z"
                stroke="#00FFF2"
                strokeWidth="0.756725"
                strokeMiterlimit="2.61313"
              />
            </svg>
          </div>

          {isLoadingGget && (
            <div className="absolute w-[92.68867924528302vw]    rounded-[1.886792452830189vw] bottom-[0vw] top-[37.5vw] backdrop-blur-sm z-[1000]">
              <div className="w-full h-full backdrop-blur-[2px] z-[550]">
                <Loader width={12} top={0} right={0} />
              </div>
            </div>
          )}

          <div className="absolute w-[92.68867924528302vw] bg-[#04181F] opacity-80 border-[1px] border-color-primary-D rounded-[1.886792452830189vw] bottom-[0vw] top-[37.5vw]  "></div>

          <div className="relative flex w-full justify-between mt-[6vw] px-[6.5vw]  ">
            <div className="relative flex flex-col items-center justify-between">
              <div className="relative flex items-center justify-between mx-[3.5vw]">
                <div className="relative w-[15vw] h-full flex items-center justify-center  p-[1vw] rounded-[1.8vw]  ">
                  <BsTrash3 size={21} color={"#fdb92e"} onClick={deleteCar} />
                </div>
                <MaskedInput
                  value={carID}
                  className="w-full h-[10vw] text-[5.5vw]  focus:text-[5.5vw] text-color-primary-D focus:text-color-primary-D font-font_primary_D focus:font-font_primary_D outline-none bg-transparent text-center flex items-center justify-center leading-[10vw]"
                  dir="ltr"
                  type="text"
                  mask={[
                    /[۰ -۹]|[0-9]/,
                    /[۰ -۹]|[0-9]/,
                    /[۰ -۹]|[0-9]/,
                    "-",
                    /[۰ -۹]|[0-9]/,
                    /[۰ -۹]|[0-9]/,
                    /[۰ -۹]|[0-9]/,
                    "-",
                    /[۰ -۹]|[0-9]/,
                    /[۰ -۹]|[0-9]/,
                    /[۰ -۹]|[0-9]/,
                  ]}
                  guide={false}
                  disabled
                />
              </div>
              {/* //// plate section start //// */}
              <div className="relative w-full h-full flex justify-center  ">
                <div className="relative w-full flex justify-center   ">
                  <div className="absolute w-[54.00943396226415vw] h-[11.01179245283019vw] bottom-0">
                    <svg
                      width="54.00943396226415vw"
                      height="11.01179245283019vw"
                      viewBox="0 0 716 146"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.66016 0.00317383H707.889C710.142 0.00317383 711.945 0.90437 713.747 2.25616C715.099 3.60796 716 5.86095 716 7.66334V138.337C716 140.139 715.099 142.392 713.747 143.744C711.945 145.096 710.142 145.997 707.889 145.997H7.66016C5.85777 145.997 3.60478 145.096 2.25299 143.744C0.901196 142.392 0 140.139 0 138.337V7.66334C0 5.86095 0.901196 3.60796 2.25299 2.25616C3.60478 0.90437 5.85777 0.00317383 7.66016 0.00317383ZM63.9849 3.15736V142.843H546.125V3.15736H63.9849ZM60.8307 142.843V3.15736H7.66016C6.30837 3.15736 5.40717 3.60796 4.50598 4.50915C3.60478 5.41035 3.15419 6.31154 3.15419 7.66334V138.337C3.15419 139.238 3.60478 140.59 4.50598 141.491C5.40717 142.392 6.30837 142.843 7.66016 142.843H60.8307ZM549.279 3.15736V142.843H707.889C709.241 142.843 710.593 142.392 711.494 141.491C711.945 140.59 712.846 139.238 712.846 138.337V7.66334C712.846 6.31154 711.945 5.41035 711.494 4.50915C710.593 3.60796 709.241 3.15736 707.889 3.15736H549.279Z"
                        fill="#00FFF2"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M9.01196 104.992V87.8698H11.265V104.992H9.01196ZM20.2769 104.992V87.8698H27.0359C27.9371 87.8698 29.2889 87.8698 29.7395 88.3203C30.6407 88.3203 31.0913 89.2215 31.5419 89.6721C31.9925 90.5733 31.9925 91.4745 31.9925 92.3757C31.9925 93.7275 31.5419 94.6287 31.0913 95.5299C30.1901 96.4311 29.2889 96.8817 27.9371 96.8817C28.3877 97.3323 28.8383 97.7829 29.2889 97.7829C29.7395 98.6841 30.1901 99.1347 30.6407 100.036L33.3442 104.992H30.6407L28.8383 101.388C28.3877 100.486 27.9371 99.5853 27.4865 99.1347C27.0359 98.2335 26.5853 98.2335 26.5853 97.7829C26.1347 97.7829 25.6841 97.3323 25.6841 97.3323C25.2335 97.3323 24.7829 97.3323 24.3323 97.3323H22.0793V104.992H20.2769ZM22.0793 95.5299H26.5853C27.4865 95.5299 27.9371 95.0793 28.3877 95.0793C28.8383 94.6287 29.2889 94.6287 29.7395 94.1781C29.7395 93.7275 30.1901 92.8263 30.1901 92.3757C30.1901 91.4745 29.7395 91.0239 29.2889 90.5733C28.8383 90.1227 27.9371 89.6721 27.0359 89.6721H22.0793V95.5299ZM43.2574 131.578V114.455H45.0598L52.72 127.973V114.455H54.5223V131.578H52.72L45.0598 118.06V131.578H43.2574ZM27.9371 131.578L33.3442 114.455H35.5972L41.455 131.578H39.202L37.8502 126.621H31.5419L29.7395 131.578H27.9371ZM31.9925 124.368H36.949L35.5972 119.862C35.1466 118.51 34.696 117.159 34.2454 116.257C34.2454 117.159 33.7948 118.51 33.7948 119.412L31.9925 124.368ZM14.4191 131.578V114.455H21.1781C22.5299 114.455 23.4311 114.455 23.8817 114.906C24.7829 115.356 25.2335 115.807 25.6841 116.708C26.1347 117.159 26.1347 118.06 26.1347 118.961C26.1347 120.313 26.1347 121.214 25.2335 122.115C24.7829 123.016 23.4311 123.467 22.0793 123.918C22.5299 123.918 22.9805 124.368 23.4311 124.819C23.8817 125.269 24.3323 126.171 24.7829 127.072L27.4865 131.578H25.2335L22.9805 127.973C22.5299 127.072 22.0793 126.171 21.6287 125.72C21.1781 125.269 21.1781 124.819 20.7275 124.368C20.2769 124.368 20.2769 124.368 19.8263 123.918C19.8263 123.918 19.3757 123.918 18.9251 123.918H16.6721V131.578H14.4191ZM16.6721 122.115H20.7275C21.6287 122.115 22.0793 122.115 22.9805 121.665C23.4311 121.665 23.8817 121.214 23.8817 120.763C24.3323 120.313 24.3323 119.862 24.3323 118.961C24.3323 118.51 23.8817 117.609 23.4311 117.159C22.9805 116.708 22.0793 116.257 21.1781 116.257H16.6721V122.115ZM9.01196 131.578V114.455H11.265V131.578H9.01196ZM35.1466 104.992V102.289H37.3996V104.992H35.1466ZM14.8697 104.992V102.289H16.6721V104.992H14.8697Z"
                        fill="#00FFF2"
                      />
                      <path
                        d="M60.8307 142.843V3.15735H7.66015C6.30836 3.15735 5.40716 3.60795 4.50597 4.50914C3.60477 5.41034 3.15417 6.31153 3.15417 7.66333V138.337C3.15417 139.238 3.60477 140.59 4.50597 141.491C5.40716 142.392 6.30836 142.843 7.66015 142.843H60.8307Z"
                        fill="#00FFF2"
                        fillOpacity="0.2"
                      />
                    </svg>
                  </div>

                  <div
                    dir="rtl"
                    className="relative flex items-end justify-between bottom-[2.5vw]  "
                  >
                    <MaskedInput
                      mask={[/[۰۱۲۳۴۵۶۷۸۹0-9]/, /[۰۱۲۳۴۵۶۷۸۹0-9]/]}
                      guide={false}
                      ref={plk3}
                      value={pInp3}
                      type="tel"
                      dir="ltr"
                      disabled={carID?.includes("IRI") ? false : true}
                      className={`w-[8.5vw] h-[5.971698113207547vw] ${
                        carID?.includes("IRI")
                          ? "bg-[rgba(226,227,229,0.2)]"
                          : "bg-transparent"
                      }  ml-[4vw]  text-color-primary-ImportBoxText focus:text-color-primary-ImportBoxText flex items-center justify-center text-center text-[7vw] focus:text-[7vw] font-font_primary_A1 focus:font-font_primary_A1 outline-none leading-[5.9vw] `}
                      onChange={(e) => {
                        setPInp3(p2e(e.target.value));
                        if (
                          setValidPlateNumber(
                            pInp1,
                            plateModalLetter,
                            pInp2,
                            e.target.value
                          ).length === 9
                        ) {
                          plk3.current.inputElement.blur();
                        }
                      }}
                      onClick={() => {
                        if (pInp2.length < 3) {
                          const end = pInp2.length;
                          plk2.current.inputElement.focus();
                          plk2.current.inputElement.setSelectionRange(end, end);
                        }
                        if (pInp1.length < 2) {
                          plk1.current.inputElement.focus();
                        }
                      }}
                      onKeyUp={(e) => {
                        if (e.key === "Backspace") {
                          if (e.target.value === "") {
                            const end = pInp2.length;
                            plk2.current.inputElement.focus();
                            plk2.current.inputElement.setSelectionRange(
                              end,
                              end
                            );
                          }
                        }
                      }}
                    />
                    <MaskedInput
                      mask={[
                        /[۰۱۲۳۴۵۶۷۸۹0-9]/,
                        /[۰۱۲۳۴۵۶۷۸۹0-9]/,
                        /[۰۱۲۳۴۵۶۷۸۹0-9]/,
                      ]}
                      guide={false}
                      ref={plk2}
                      value={pInp2}
                      type="tel"
                      dir="ltr"
                      disabled={carID?.includes("IRI") ? false : true}
                      className={`w-[14.3vw] h-[5.971698113207547vw] ${
                        carID?.includes("IRI")
                          ? "bg-[rgba(226,227,229,0.2)]"
                          : "bg-transparent"
                      } ml-[2vw] text-color-primary-ImportBoxText focus:text-color-primary-ImportBoxText flex items-center justify-center text-center text-[7vw] focus:text-[7vw] font-font_primary_A1 focus:font-font_primary_A1 outline-none leading-[5.9vw]`}
                      onChange={(e) => {
                        setPInp2(p2e(e.target.value));
                        if (e.target.value.length === 3) {
                          plk3.current.inputElement.focus();
                        }
                      }}
                      onClick={() => {
                        if (pInp1.length < 2) {
                          plk1.current.inputElement.focus();
                        }
                      }}
                      onKeyUp={(e) => {
                        if (e.key === "Backspace") {
                          if (e.target.value === "") {
                            setPlateModalLetter("");
                            const end = pInp1.length;
                            plk1.current.inputElement.focus();
                            plk1.current.inputElement.setSelectionRange(
                              end,
                              end
                            );
                          }
                        }
                      }}
                    />
                    <div
                      className={` w-[6.344339622641509vw] h-[5.971698113207547vw] leading-[6vw]  z-50 ml-[2vw]  ${
                        carID?.includes("IRI")
                          ? "bg-[rgba(226,227,229,0.2)] "
                          : "bg-transparent"
                      } flex items-center justify-center text-center text-color-primary-ImportBoxText  text-[5vw] font-font_primary_A outline-none leading-[5.9vw]`}
                      onClick={() => {
                        if (carID?.includes("IRI")) {
                          if (pInp1.length < 2) {
                            const end = pInp1.length;
                            plk1.current.inputElement.focus();
                            plk1.current.inputElement.setSelectionRange(
                              end,
                              end
                            );
                          }
                          if (pInp1.length === 2) {
                            setIsPlateModalOpen(true);
                          }
                        }
                      }}
                    >
                      <span>
                        {pInp1 ? (
                          plateModalLetter === "&" ? (
                            <FaWheelchair size={16.5} />
                          ) : (
                            plateModalLetter
                          )
                        ) : (
                          ""
                        )}
                      </span>
                    </div>
                    <MaskedInput
                      mask={[/[۰۱۲۳۴۵۶۷۸۹0-9]/, /[۰۱۲۳۴۵۶۷۸۹0-9]/]}
                      guide={false}
                      ref={plk1}
                      value={pInp1}
                      type="tel"
                      dir="ltr"
                      disabled={carID?.includes("IRI") ? false : true}
                      className={` w-[8.5vw] h-[5.971698113207547vw] ${
                        carID?.includes("IRI")
                          ? "bg-[rgba(226,227,229,0.2)]"
                          : "bg-transparent"
                      }  text-color-primary-ImportBoxText  focus:text-color-primary-ImportBoxText flex items-center justify-center text-center focus:text-center text-[7vw] focus:text-[7vw] font-font_primary_A1 focus:font-font_primary_A1 outline-none z-50 leading-[5.9vw] `}
                      onChange={(e) => {
                        setPInp1(p2e(e.target.value));
                        if (e.target.value.length === 2) {
                          setIsPlateModalOpen(true);
                        }
                      }}
                    />
                    <div className="w-[4.7vw] "></div>
                  </div>
                </div>
              </div>
              {/* //// plate section end //// */}
            </div>
            {/* //// QR code section start //// */}
            <div
              className="relative   bg-color-primary-A p-[4px] ml-[3.7vw] rounded-[1vw]"
              onClick={() => {
                openQrCodeModal();
              }}
            >
              <QRCode
                value={carID}
                size={32}
                style={{
                  height: "20vw",
                  maxWidth: "20vw",
                  width: "20vw",
                  top: "0px",
                }}
              />

              <div className="absolute w-full h-full backdrop-blur-[1px] flex items-center justify-center z-[20]  top-0 right-0"></div>
            </div>
            {/* //// QR code section end //// */}
          </div>
          <div className="flex flex-col items-center  justify-start w-[92.68867924528302vw] top-0 mt-[12vw] pb-[2vw] overflow-auto  ">
            <div className="relative w-[82.95047169811321vw] h-[13.07547169811321vw] min-h-[13.07547169811321vw] mt-[3.7vw]">
              <span
                className={`relative top-[1vw] ${
                  carID?.includes("IRI")
                    ? "text-color-primary-D"
                    : "text-color-primary-C"
                } font-font_primary_A font-extralight text-[4vw]`}
              >
                برند
              </span>
              <div dir="ltr" className="absolute w-[72vw] top-0 left-0">
                <BrandSelect
                  setBrand={setBrand}
                  brand={brand}
                  disabled={BMChangeAble}
                  setNewBrand={setNewBrand}
                  carID={carID}
                />
              </div>
            </div>
            <div className="relative w-[82.95047169811321vw] h-[13.07547169811321vw] min-h-[13.07547169811321vw] mt-[3.7vw]">
              <span
                className={`relative top-[1vw] ${
                  carID?.includes("IRI")
                    ? "text-color-primary-D"
                    : "text-color-primary-C"
                } font-font_primary_A font-extralight text-[4vw]`}
              >
                مدل
              </span>
              <div dir="ltr" className="absolute w-[72vw] top-0 left-0">
                <ModelSelect
                  setModel={setModel}
                  setCategoryID={setCategoryID}
                  model={model}
                  disabled={BMChangeAble}
                  setNewModel={setNewModel}
                  setNewCategoryID={setNewCategoryID}
                  carID={carID}
                />
              </div>
            </div>
            <div className="relative w-[82.95047169811321vw] h-[13.07547169811321vw] min-h-[13.07547169811321vw] mt-[1.8vw]">
              <span
                className={`absolute ${
                  carID?.includes("IRI")
                    ? "text-color-primary-D"
                    : "text-color-primary-C"
                } font-font_primary_A font-extralight text-[4vw]`}
              >
                سال تولید
              </span>
              <div
                className={`w-full flex items-center justify-end border-b-[1px] ${
                  carID?.includes("IRI")
                    ? "border-color-primary-D"
                    : "border-color-primary-C"
                }`}
                onClick={() => {
                  datePickerRefPr?.current?.openCalendar();
                }}
              >
                <DatePicker
                  disabled={carID?.includes("IRI") ? false : true}
                  renderButton={(direction, handleClick) => (
                    <button
                      className="text-color-primary-D mx-[3vw] text-[5vw]"
                      onClick={handleClick}
                    >
                      {direction === "right" ? ">" : "<"}
                    </button>
                  )}
                  formatMonth={(month, year) => {
                    return (
                      <span className="text-color-primary-D font-font_primary_A ">
                        {month}
                      </span>
                    );
                  }}
                  formatYear={(year, month) => {
                    return (
                      <span className="text-color-primary-D font-font_primary_A ">
                        {year}
                      </span>
                    );
                  }}
                  highlightToday={false}
                  onOpenPickNewDate={false}
                  monthYearSeparator="|"
                  ref={datePickerRefPr}
                  minDate={`${
                    prDatePickerCalender === persian ? "1330" : "1950"
                  }`}
                  maxDate={`${
                    prDatePickerCalender === persian
                      ? new Date().getFullYear() - 619
                      : new Date().getFullYear() + 1
                  }`}
                  digits={digits}
                  onlyYearPicker={true}
                  style={{
                    backgroundColor: "transparent",
                    height: "24px",
                    width: "83vw",
                    border: "none",
                    color: `${carID?.includes("IRI") ? "white" : "#8f8c85"}`,
                    textAlign: "left",
                    fontFamily: "dateFonts",
                    fontSize: "4.5vw",
                    padding: "0",
                  }}
                  className="rmdp-mobile react-datepicker "
                  mobileLabels={{
                    OK: "ثبت",
                    CANCEL: "بستن",
                  }}
                  calendar={prDatePickerCalender}
                  locale={persian_fa}
                  calendarPosition="bottom-right"
                  value={prDateValue}
                  onChange={setPrDateValue}
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                >
                  <div className="w-full font-font_primary_A flex items-center justify-center gap-x-[8vw] text-white">
                    <button
                      className={`border-[1px] border-color-primary-D px-[4vw] rounded-[1.8vw] ${
                        prDatePickerCalender === ""
                          ? "bg-color-primary-D text-black rounded-[1.8vw] flex items-center justify-center"
                          : ""
                      }`}
                      onClick={() => setPrDatePickerCalender("")}
                    >
                      میلادی
                    </button>
                    <button
                      className={`border-[1px] border-color-primary-D px-[4vw] rounded-[1.8vw] ${
                        prDatePickerCalender === persian
                          ? "bg-color-primary-D text-black rounded-[1.8vw] flex items-center justify-center "
                          : ""
                      }`}
                      onClick={() => setPrDatePickerCalender(persian)}
                    >
                      شمسی
                    </button>
                  </div>
                </DatePicker>
              </div>
            </div>
            <div className="relative w-[82.95047169811321vw] h-[13.07547169811321vw] min-h-[13.07547169811321vw] mt-[1.8vw]">
              <span className="absolute text-color-primary-D font-font_primary_A font-extralight text-[4vw]">
                کارکرد
              </span>
              <input
                type="text"
                dir="ltr"
                value={addCommas(removeNonNumeric(p2e(func)))}
                maxLength={7}
                className="relative w-[82.95047169811321vw] text-left bg-transparent border-b-[1px] border-color-primary-D leading-[6vw] outline-none text-color-primary-A focus:text-color-primary-A text-[4.5vw] focus:text-[4.5vw] font-font_primary_D focus:font-font_primary_D"
                onChange={(e) => {
                  setFunc(addCommas(removeNonNumeric(p2e(e.target.value))));
                }}
              />
            </div>

            <div className="relative w-[82.95047169811321vw] h-[13.07547169811321vw] min-h-[13.07547169811321vw] mt-[1.8vw]">
              <span className="absolute text-color-primary-C font-font_primary_A font-extralight text-[4vw]">
                کیلومتر آخرین سرویس
              </span>
              <input
                type="text"
                dir="ltr"
                value={addCommas(removeNonNumeric(p2e(lastReplace)))}
                maxLength={7}
                disabled
                className="relative w-[82.95047169811321vw] text-left bg-transparent border-b-[1px] border-color-primary-C outline-none text-color-primary-C focus:text-color-primary-C text-[4.5vw] focus:text-[4.5vw] font-font_primary_D focus:font-font_primary_D leading-[6vw]"
                onChange={(e) => {
                  setLastReplace(
                    addCommas(removeNonNumeric(p2e(e.target.value)))
                  );
                }}
              />
            </div>
            <div className="relative w-[82.95047169811321vw] h-[13.07547169811321vw] min-h-[13.07547169811321vw] mt-[1.8vw]">
              <span className="absolute text-color-primary-D font-font_primary_A font-extralight text-[4vw]">
                تاریخ انقضا بیمه شخص ثالث
              </span>
              <div
                className={`w-full   flex items-center justify-end  border-b-[1px] border-color-primary-D  `}
                onClick={() => {
                  datePickerRefInsurance?.current?.openCalendar();
                }}
              >
                <DatePicker
                  renderButton={(direction, handleClick) => (
                    <button
                      className="text-color-primary-D mx-[3vw] text-[5vw] z-50"
                      onClick={handleClick}
                    >
                      {direction === "right" ? ">" : "<"}
                    </button>
                  )}
                  formatMonth={(month, year) => {
                    return (
                      <span className="text-color-primary-D font-font_primary_A">
                        {month}
                      </span>
                    );
                  }}
                  formatYear={(year, month) => {
                    return (
                      <span className="text-color-primary-D font-font_primary_A">
                        {year}
                      </span>
                    );
                  }}
                  highlightToday={false}
                  onOpenPickNewDate={false}
                  mapDays={({
                    date,
                    today,
                    selectedDate,
                    currentMonth,
                    isSameDate,
                  }) => {
                    let props = {};

                    props.style = {
                      borderRadius: "3px",
                      color: "white",
                    };

                    if (isSameDate(date, selectedDate))
                      props.style = {
                        ...props.style,
                        color: "#000000",
                        backgroundColor: "#00F7FF",
                        fontWeight: "bold",
                        border: "1px solid #00F7FF",
                      };

                    return props;
                  }}
                  monthYearSeparator="|"
                  ref={datePickerRefInsurance}
                  minDate="1402/01/01"
                  maxDate="1403/12/30"
                  digits={digits}
                  style={{
                    backgroundColor: "transparent",
                    height: "24px",
                    width: "82vw",
                    border: "none",
                    color: "white",
                    textAlign: "left",
                    fontFamily: "dateFonts",
                    fontSize: "4.5vw",
                    padding: "0",
                  }}
                  className="rmdp-mobile react-datepicker "
                  mobileLabels={{
                    OK: "ثبت",
                    CANCEL: "بستن",
                  }}
                  calendar={persian}
                  locale={persian_fa}
                  calendarPosition="bottom-right"
                  value={insuranceDateValue}
                  onChange={(e) => {
                    let x = e?.year;
                    let y = e?.month?.number;
                    let z = e?.day;
                    setMustSendInsuranceDate(() => {
                      if (y < 10) {
                        y = "0" + y;
                      }
                      if (z < 10) {
                        z = "0" + z;
                      }
                      return `${x}-${y}-${z}`;
                    });
                    setInsuranceDateValue(
                      new DateObject({
                        date: `${x}/${y}/${z}`,
                        calendar: persian,
                      })
                    );
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                />
              </div>
            </div>
            <div className="relative w-[82.95047169811321vw] h-[13.07547169811321vw] min-h-[13.07547169811321vw] mt-[1.8vw]">
              <span
                className={`absolute ${
                  carID?.includes("IRI")
                    ? "text-color-primary-D"
                    : "text-color-primary-C"
                } font-font_primary_A font-extralight text-[4vw]`}
              >
                شماره موتور
              </span>
              <MaskedInput
                type="text"
                mask={[
                  /^[A-Za-z0-9]*$/,
                  /^[A-Za-z0-9]*$/,
                  /^[A-Za-z0-9]*$/,
                  /^[A-Za-z0-9]*$/,
                  /^[A-Za-z0-9]*$/,
                  /^[A-Za-z0-9]*$/,
                  /^[A-Za-z0-9]*$/,
                  /^[A-Za-z0-9]*$/,
                  /^[A-Za-z0-9]*$/,
                  /^[A-Za-z0-9]*$/,
                  /^[A-Za-z0-9]*$/,
                  /^[A-Za-z0-9]*$/,
                  /^[A-Za-z0-9]*$/,
                  /^[A-Za-z0-9]*$/,
                  /^[A-Za-z0-9]*$/,
                  /^[A-Za-z0-9]*$/,
                  /^[A-Za-z0-9]*$/,
                ]}
                guide={false}
                dir="ltr"
                value={engineNumber}
                maxLength={17}
                disabled={carID?.includes("IRI") ? false : true}
                className={`relative w-[82.95047169811321vw] text-left bg-transparent border-b-[1px] ${
                  carID?.includes("IRI")
                    ? "border-color-primary-D"
                    : "border-color-primary-C"
                } leading-[6vw] text-left bg-transparent outline-none ${
                  carID?.includes("IRI")
                    ? "text-color-primary-A focus:text-color-primary-A"
                    : "text-color-primary-C focus:text-color-primary-C"
                }   leading-[6vw] outline-none  text-[4.5vw] focus:text-[4.5vw] font-font_primary_D focus:font-font_primary_D`}
                onChange={engineNumberHandle}
              />
            </div>
            <div className="relative w-[82.95047169811321vw] h-[13.07547169811321vw] min-h-[13.07547169811321vw] mt-[1.8vw]">
              <span
                className={`absolute ${
                  carID?.includes("IRI")
                    ? "text-color-primary-D"
                    : "text-color-primary-C"
                } font-font_primary_A font-extralight text-[4vw]`}
              >
                شماره شاسی
              </span>
              <MaskedInput
                type="text"
                mask={[
                  /^[A-Za-z0-9]*$/,
                  /^[A-Za-z0-9]*$/,
                  /^[A-Za-z0-9]*$/,
                  /^[A-Za-z0-9]*$/,
                  /^[A-Za-z0-9]*$/,
                  /^[A-Za-z0-9]*$/,
                  /^[A-Za-z0-9]*$/,
                  /^[A-Za-z0-9]*$/,
                  /^[A-Za-z0-9]*$/,
                  /^[A-Za-z0-9]*$/,
                  /^[A-Za-z0-9]*$/,
                  /^[A-Za-z0-9]*$/,
                  /^[A-Za-z0-9]*$/,
                  /^[A-Za-z0-9]*$/,
                  /^[A-Za-z0-9]*$/,
                  /^[A-Za-z0-9]*$/,
                  /^[A-Za-z0-9]*$/,
                ]}
                guide={false}
                dir="ltr"
                value={frameNumber}
                maxLength={17}
                disabled={carID?.includes("IRI") ? false : true}
                className={`relative w-[82.95047169811321vw] text-left bg-transparent border-b-[1px] ${
                  carID?.includes("IRI")
                    ? "border-color-primary-D"
                    : "border-color-primary-C"
                } leading-[6vw] text-left bg-transparent outline-none ${
                  carID?.includes("IRI")
                    ? "text-color-primary-A focus:text-color-primary-A"
                    : "text-color-primary-C focus:text-color-primary-C"
                }  leading-[6vw] outline-none  text-[4.5vw] focus:text-[4.5vw] font-font_primary_D focus:font-font_primary_D`}
                onChange={frameNumberHandle}
              />
            </div>
          </div>
        </div>

        {/* ////// */}
        {/* ////// */}

        {/* //// sabt buttun section start //// */}
        <div className="absolute bottom-[3.681603773584906vw] w-full flex items-center justify-center mt-[1.937046004842615vh] ">
          {isLoading ? (
            <>
              <div className="w-[92.68867924528302vw] h-[16.9811320754717vw] bg-[#001D26] opacity-70 border-[1px] border-color-primary-D rounded-[1.886792452830189vw] flex items-center justify-center text-[#00FFF2] font-font_primary_A text-[7.547169811320755vw]">
                <BlueLoader position="" width={20} />
              </div>
            </>
          ) : (
            <>
              <button
                className="w-[92.68867924528302vw] h-[16.9811320754717vw] font-bold bg-[#001D26] opacity-70 border-[1px] border-color-primary-D rounded-[1.886792452830189vw] flex items-center justify-center text-[#00FFF2] font-font_primary_A text-[7.547169811320755vw]"
                onClick={changeCarDetails}
              >
                ثبت
              </button>
            </>
          )}
        </div>
        {/* //// sabt buttun section end //// */}
      </div>
    </>
  );
}
